module.exports = __webpack_public_path__ + "media/images/illust/illust-g40s-7c4e645934f7b6d13ae8cb0feb73a870.svg";